// @ts-nocheck
import React from "react";
import { usePaymentDetails } from "../../PaymentDetailsProvider";
import { Checkbox } from "antd";
import { Typography } from "src/components/Core/Typography";
import { Box } from "src/components/Core/Box";

interface Props {
  isChecked: boolean;
  setFieldValue: Function;
  setFieldTouched: Function;
}

const PayingAgency: React.FC<Props> = ({
  isChecked,
  setFieldValue,
  setFieldTouched,
}) => {
  const { actions } = usePaymentDetails();

  return (
    <Box display="inline-flex">
      <Checkbox
        name="payingAgency"
        onChange={() => {
          setFieldTouched("payingAgency");
          setFieldValue("payingAgency", !isChecked);
          setFieldValue("vatNumber", "");
          setFieldValue("accountId", "");
          actions.setExistingPaymentDetails({});
          actions.setActualPaymentDetails({});
        }}
        value={isChecked}
        data-cy="checkbox-payingAgency"
      />
      <Typography size={12} color="grey9" ml={10} mt={0.9}>
        I’m paying a Talent Agency for this campaign
      </Typography>
    </Box>
  );
};

export default PayingAgency;
